import { Box, Stack, useTheme } from "@mui/material";
import TitleComponent from "../../../components/widgets/titleComponent";
import { useTranslation } from "react-i18next";
import CarouselComponent from "../../../components/widgets/carouselComponent/carouselComponent";
import TestimonialBox from "./testimonialBox";
import { useCallback } from "react";
import companyData from '../../../assets/data/company.json';

const TestimonialsLayout = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const getTestimonialsList = useCallback(() => {
        const list = [];

        for(let i = 0; i < companyData.testimonials.length; i++){
            list.push(<TestimonialBox client={companyData.testimonials[i]}/>);
        }

        return list;
    }, [companyData]);

    return (
        <>
            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pb: 10
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >
                    <TitleComponent 
                        title={t('testimonials.title')}
                        description={t('testimonials.description')}
                    />

                    {
                        companyData.testimonials.length > 1
                        ?
                        <CarouselComponent list={getTestimonialsList()}/>
                        :
                        <>
                            {
                                companyData.testimonials.length === 1
                                ?
                                <TestimonialBox 
                                    client={companyData.testimonials[0]} 
                                    fullWidth
                                />
                                :
                                <></>
                            }
                        </>
                    }
                </Stack>
            </Box>
        </>
    );
}

export default TestimonialsLayout;